import type { IconProps } from '../types/IconProps.ts';
export const LockOpenKeyhole: IconProps = {
    name: 'LockOpenKeyhole',
    children: [
        `<path d="M20 10H4c-.55 0-1 .49-1 1.1v9.8c0 .61.45 1.1 1 1.1h16c.55 0 1-.49 1-1.1v-9.8c0-.61-.45-1.1-1-1.1" />`,
        `<path d="M16.87 5c-.52-1.87-2.5-3-4.87-3-2.76 0-5 1.99-5 4.44V10M12 17a1 1 0 1 0 0-2 1 1 0 0 0 0 2" />`,
    ]
};